import { Stack, Typography, Button, Card, Box } from '@mui/material';

export default function ConfigInicial({ seleccionarMetodo }) {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
      <Card sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" mb={3}>Selecciona Método de Valuación</Typography>
        <Stack spacing={2}>
          {[
            // 'PEPS', 'UEPS', 
            'PROMEDIO'].map(m => (
            <Button key={m} variant="contained" onClick={() => seleccionarMetodo(m)}>{m}</Button>
          ))}
        </Stack>
      </Card>
    </Box>
  );
}